// Import the generic hook
import useEntity from "../generic/useEntity.jsx";

// API
import { getSubTask } from "../../api/tasks.jsx";

// Redux actions
import { setSelectedSubTask, clearSelectedSubTask } from "../../redux/slices/clientBoardSlice";

/**
 * Custom hook for fetching subtask details
 * Wrapper around generic useEntity hook for backward compatibility
 * @param {string} subtaskId - ID of the subtask to fetch
 * @param {boolean} enabled - Whether the fetch should be enabled
 * @returns {Object} Object containing subtask from store, loading state, error and refetch function
 */
const useSubtask = (subtaskId, enabled = true) => {
  const config = {
    fetchFn: getSubTask,
    selectFn: (state) => state.clientBoard.selectedSubTask,
    setActionFn: setSelectedSubTask,
    clearActionFn: clearSelectedSubTask,
    entityName: "subtask"
  };

  const result = useEntity(subtaskId, enabled, config);

  return {
    subtask: result.subtask,
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch
  };
};

export default useSubtask;
